module.exports = __webpack_public_path__ + "static/media/linkedIn.c1eb2740.svg";